// Others
import axiosClient from './axiosClient';
import { urlApiEstimateTemplate } from '~/utils/constants/apis';
import { IQueryParamBase } from '~/utils/interface/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IEstimateTemplate,
  IEstimateTemplateDetails,
  IUpdateTemplateBody,
} from '~/utils/interface/estimateTemplate';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';

const estimateTemplateApi = {
  getEstimateTemplateList: (params: IQueryParamBase) => {
    const url = urlApiEstimateTemplate.getEstimateTemplateList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IEstimateTemplate[]>>>(url, { params });
  },

  createEstimateTemplate: (formData: FormData) => {
    const url = urlApiEstimateTemplate.createEstimateTemplate;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  deleteEstimateTemplate: (estimateTemplateId: string) => {
    const url = urlApiEstimateTemplate.deleteEstimateTemplate(estimateTemplateId);
    return axiosClient.delete<IBaseResponse>(url);
  },

  updateEstimateTemplate: ({ templateId, formData }: IUpdateTemplateBody) => {
    const url = urlApiEstimateTemplate.updateEstimateTemplate(templateId);
    return axiosClient.put<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  getEstimateTemplateDetails: (templateId: string) => {
    const url = urlApiEstimateTemplate.getEstimateTemplateDetails(templateId);
    return axiosClient.get<IBaseResponse<IEstimateTemplateDetails>>(url);
  },
};

export default estimateTemplateApi;
